import axios from "axios";
import { toast } from "react-toastify";
import { RiErrorWarningLine } from "react-icons/ri";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL, //"http://localhost:4200",
  headers: {
    "Content-type": "application/json",
  },
});
// Add a request auth header
axiosInstance.interceptors.request.use(function (config) {
  // const user = JSON.parse(localStorage.getItem("user"));

  config.withCredentials = true;
  // if (user && user.access_token) {
  //     config.headers.Authorization = "Bearer " + user.access_token;
  // }

  return config;
});

axiosInstance.interceptors.response.use(
  (response) => {
    // intercept response...
    return response;
  },
  (error) => {
    let errorText = "";
    // intercept errors
    if (error.response) {
      //if 401 check if refresh token is possible...
      const originalRequest = error.config;
      if (
        error.response.status === 401 &&
        originalRequest.url !== "/auth/refresh"
      ) {
        return axiosInstance
          .get("/auth/refresh")
          .then((res) => {
            if (res.status === 201 || res.status === 200) {
              return axiosInstance(originalRequest);
            }
          })
          .catch((err) => {
            //if refresh token get error, logout
            localStorage.setItem("logout", true);
            window.location = "/";
            return Promise.reject(err.response);
          });
      }
      errorText = error.response.data.message;
    } else {
      errorText = "Server non raggiungibile...";
    }
    const errorMessage = () => (
      <div>
        <strong>
          <RiErrorWarningLine size={24} /> ERRORE
        </strong>
        <br />
        <small>{errorText}</small>
      </div>
    );
    toast.error(errorMessage, {
      className: "bg-danger",
    });

    return Promise.reject(error.response);
  }
);
// You can create/export more then one
export { axiosInstance };

export default axiosInstance;
